<template>
    <div class="flex flex-col items-center justify-center w-full ">
        <wide-card>
           <!--  <base-tips-alert>
                <p class="my-0 mt-1 text-gray-700">
                    Votre projet doit être cohérent par rapport à vos
                    compétences, votre personalité, votre potentiel, votre
                    situation familiale et vos contraintes personnelles.
                </p>
                <p class="my-0 mt-1 text-gray-700">
                    Planifiez bien votre projet pour lancer l'activité dans le
                    moment le plus favorable.
                </p>
            </base-tips-alert> -->
            <base-input
                placeholder="Titre du projet"
                v-model="project.title"
                :hasError="$v.project.title.$error"
                :errorMessage="
                    errorMessage('Titre du projet', $v.project.title)
                "
                @blur="$v.project.title.$touch()"
            />
            <base-input-textarea
                label="Quel est le problème auquel vous vous attaquez et quelle est la solution que vous proposez?"
                placeholder="Description du projet*

Quelle est le le problème auquel vous vous attaquez ? et quelle est son importance ?

Quelle est la solution que vous proposez (Ce que vous faites concrètement) ?

Quelles sont vos atouts face à la concurrence ?"
                v-model="project.description"
                :hasError="$v.project.description.$error"
                :errorMessage="
                    errorMessage(
                        'Description du projet',
                        $v.project.description
                    )
                "
                @blur="$v.project.description.$touch()"
            />
            <date-picker
                label="Date de démarrage effectif du projet "
                :value="
                    project.startDate.seconds !== undefined
                        ? new Date(project.startDate.seconds * 1000)
                        : project.startDate
                "
                v-on:setDate="payload => (project.startDate = payload)"
            />
            <small-check-box
                label="J’ai pas encore démarrer mon projet"
                v-model="project.isStarted"
            />
            <select-menu
                label="Choix de Secteur"
                :option="sectors"
                v-model="project.sector"
                :hasError="$v.project.sector.$error"
                :errorMessage="errorMessage('Secteur', $v.project.sector)"
            />
            <select-menu
                label="Choix de Branche"
                :option="branch"
                v-model="project.branch"
                :hasError="$v.project.branch.$error"
                :errorMessage="errorMessage('Branche', $v.project.sector)"
            />
            <select-menu
                label="Choix de Sous Branche"
                :option="sousBranch"
                v-model="project.subBranch"
                :hasError="$v.project.subBranch.$error"
                :errorMessage="errorMessage('Branche', $v.project.subBranch)"
            />
            <select-menu
                label="Choix de l'Activité"
                :option="activity"
                v-model="project.activity"
                :hasError="$v.project.activity.$error"
                :errorMessage="errorMessage('activité', $v.project.activity)"
            />
        </wide-card>
        <base-primary-button title="Suivant" @click="createProject" />
    </div>
</template>

<script>
import SmallCheckBox from "../../../../components/forms/Toggles/smallCheckBox";
import WideCard from "../../../../components/cards/wideCard";
import SelectMenu from "../../../../components/forms/select/selectMenu";
import DatePicker from "../../../../components/forms/DatePicker";
import { mapGetters } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        WideCard,
        SmallCheckBox,
        SelectMenu,
        DatePicker
    },

    mixins: [errorMessage, scrollToError],

    validations: {
        project: {
            title: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(150)
            },
            description: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(1500)
            },
            startDate: { required },
            sector: { required },
            branch: { required },
            subBranch: { required },
            activity: { required }
        }
    },
    computed: {
        ...mapGetters("forms", {
            sectors: "getsectors",
            SubSectors: "getSubSectors"
        }),
        branch() {
            if (this.project.sector === 0) return;
            return this.SubSectors(parseInt(this.project.sector));
        },
        activity() {
            if (this.project.subBranch === 0) return;
            return this.SubSectors(parseInt(this.project.subBranch));
        },
        sousBranch() {
            if (this.project.branch === 0) return;
            return this.SubSectors(parseInt(this.project.branch));
        }
    },
    data() {
        return {
            project: {}
        };
    },

    created() {
        this.project = this.$store.getters["VotreProject/getProject"];
        this.$store.dispatch("forms/currentStepVotreProject", "Votre Projet");
    },

    methods: {
        createFreshProjectObject() {
            return {
                title: "",
                description: "",
                startDate: "",
                isStarted: null,
                sector: 0,
                branch: 0,
                subBranch: 0,
                activity: 0
            };
        },
        createProject() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store
                    .dispatch("VotreProject/creatProject", this.project)
                    .then(() => {
                        this.$store.dispatch("VotreProject/SaveProject");
                        this.$store.dispatch(
                            "forms/completStep",
                            "Votre Projet"
                        );

                        this.$router.push({
                            name: "vos_offres",
                            params: { uid: `${this.$store.state.user.bpiId}` }
                        });
                    });
            } else {
                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
                this.scrollToError();
            }
        }
    }
};
</script>

<style></style>
